import { render } from "./classModel.vue?vue&type=template&id=7d794956&scoped=true"
import script from "./classModel.vue?vue&type=script&lang=js"
export * from "./classModel.vue?vue&type=script&lang=js"

import "./classModel.vue?vue&type=style&index=0&id=7d794956&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d794956"]])

export default __exports__